import { IsOptional, IsString, IsUUID } from 'class-validator';

export class GetOptionsDto {
  @IsString()
  @IsOptional()
  eventTypeGroup?: string;

  @IsUUID()
  @IsString()
  @IsOptional()
  parentEventId?: string;
}
